module.exports = __webpack_public_path__ + "img/enterprise-competition-2024-schedule-open-group-2.b6f07e30.jpg";